import {
  runAccessibilityScan as publicRunAccessibilityScan,
  listAccessibilityScanPageCollections as publicListAccessibilityScanPageCollections,
  listAccessibilityScanPageSummaries as publicListAccessibilityScanPageSummaries,
  getLatestAccessibilityScan as publicGetLatestAccessibilityScan,
  getAccessibilityScan as publicGetAccessibilityScan,
  listAccessibilityScanFindings as publicListAccessibilityScanFindings,
} from './accessibility-v1-accessibility-scan-accessibility-scans.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const runAccessibilityScan: MaybeContext<
  BuildRESTFunction<typeof publicRunAccessibilityScan> &
    typeof publicRunAccessibilityScan
> = /*#__PURE__*/ createRESTModule(publicRunAccessibilityScan);
export const listAccessibilityScanPageCollections: MaybeContext<
  BuildRESTFunction<typeof publicListAccessibilityScanPageCollections> &
    typeof publicListAccessibilityScanPageCollections
> = /*#__PURE__*/ createRESTModule(publicListAccessibilityScanPageCollections);
export const listAccessibilityScanPageSummaries: MaybeContext<
  BuildRESTFunction<typeof publicListAccessibilityScanPageSummaries> &
    typeof publicListAccessibilityScanPageSummaries
> = /*#__PURE__*/ createRESTModule(publicListAccessibilityScanPageSummaries);
export const getLatestAccessibilityScan: MaybeContext<
  BuildRESTFunction<typeof publicGetLatestAccessibilityScan> &
    typeof publicGetLatestAccessibilityScan
> = /*#__PURE__*/ createRESTModule(publicGetLatestAccessibilityScan);
export const getAccessibilityScan: MaybeContext<
  BuildRESTFunction<typeof publicGetAccessibilityScan> &
    typeof publicGetAccessibilityScan
> = /*#__PURE__*/ createRESTModule(publicGetAccessibilityScan);
export const listAccessibilityScanFindings: MaybeContext<
  BuildRESTFunction<typeof publicListAccessibilityScanFindings> &
    typeof publicListAccessibilityScanFindings
> = /*#__PURE__*/ createRESTModule(publicListAccessibilityScanFindings);

export {
  TargetType,
  AccessibilityScanScope,
  AccessibilityScanStatus,
  AccessibilitySeverity,
  AccessibilityFindingCategory,
  AccessibilityScanFailureCode,
  AccessibilityPageScanStatus,
  WcagLevel,
  AccessibilityFixCategory,
} from './accessibility-v1-accessibility-scan-accessibility-scans.universal.js';
export {
  AccessibilityScan,
  AccessibilityScanTarget,
  AccessibilityScanTargetTargetOneOf,
  PageScanTarget,
  PageScanTargetIdentifierOneOf,
  PageCollectionScanTarget,
  AccessibilityScanProgress,
  AccessibilityScanSummary,
  AccessibilitySeverityCount,
  AccessibilityFindingCategoryCount,
  AccessibilityScanCoverage,
  AccessibilityScanFailure,
  RunAccessibilityScanRequest,
  RunAccessibilityScanResponse,
  ExistingAccessibilityScanError,
  ScanSizeLimitExceededError,
  AccessibilityScanStateUnknownError,
  ListAccessibilityScanPageCollectionsRequest,
  CursorPaging,
  ListAccessibilityScanPageCollectionsResponse,
  AccessibilityScanPageCollection,
  CursorPagingMetadata,
  Cursors,
  ListAccessibilityScanPageSummariesRequest,
  ListAccessibilityScanPageSummariesResponse,
  AccessibilityScanPageSummary,
  AccessibilityPageReference,
  AccessibilityPageCollectionReference,
  GetLatestAccessibilityScanRequest,
  GetLatestAccessibilityScanResponse,
  GetAccessibilityScanRequest,
  GetAccessibilityScanResponse,
  ListAccessibilityScanFindingsRequest,
  AccessibilityFindingFilter,
  ListAccessibilityScanFindingsResponse,
  AccessibilityFinding,
  AccessibilityElementReference,
  WcagCriterion,
  AccessibilityFixGuidance,
  RunAccessibilityScanOptions,
  ListAccessibilityScanPageCollectionsOptions,
  ListAccessibilityScanPageSummariesOptions,
  ListAccessibilityScanFindingsOptions,
} from './accessibility-v1-accessibility-scan-accessibility-scans.universal.js';
export {
  TargetTypeWithLiterals,
  AccessibilityScanScopeWithLiterals,
  AccessibilityScanStatusWithLiterals,
  AccessibilitySeverityWithLiterals,
  AccessibilityFindingCategoryWithLiterals,
  AccessibilityScanFailureCodeWithLiterals,
  AccessibilityPageScanStatusWithLiterals,
  WcagLevelWithLiterals,
  AccessibilityFixCategoryWithLiterals,
  RunAccessibilityScanApplicationErrors,
  ListAccessibilityScanPageSummariesApplicationErrors,
  GetLatestAccessibilityScanApplicationErrors,
  GetAccessibilityScanApplicationErrors,
  ListAccessibilityScanFindingsApplicationErrors,
} from './accessibility-v1-accessibility-scan-accessibility-scans.universal.js';
